export default {
  base: {
    position: 'absolute',
    top: '0',
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: '20px',
    height: '20px'
  }
}
